/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Features.css';
import phone1 from './phone-1.png';
import phone12x from './phone-1@2x.png';
import phone2 from './phone-2.png';
import phone22x from './phone-2@2x.png';
import phone3 from './phone-3.png';
import phone32x from './phone-3@2x.png';
import phone4 from './phone-4.png';
import phone42x from './phone-4@2x.png';
import phone5 from './phone-5.png';
import phone52x from './phone-5@2x.png';
import phone6 from './phone-6.png';
import phone62x from './phone-6@2x.png';
import phone7 from './phone-7.png';
import phone72x from './phone-7@2x.png';
import phone8 from './phone-8.png';
import phone82x from './phone-8@2x.png';

class Features extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.feature}>
            <h1 className={s.title}>View progress</h1>
            <p className={s.body}>
              Stay motivated by your <br />
              habit streaks
            </p>
            <div className={s.phone}>
              <img
                src={phone1}
                srcSet={`${phone12x} 2x`}
                width="379"
                height="757"
                alt="View progress"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Build new habits</h1>
            <p className={s.body}>
              A better you one <br />
              habit at a time
            </p>
            <div className={s.phone}>
              <img
                src={phone2}
                srcSet={`${phone22x} 2x`}
                width="379"
                height="757"
                alt="View progress"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Flexible planning</h1>
            <p className={s.body}>
              Specific days, interval, <br />
              or the amount
            </p>
            <div className={s.phone}>
              <img
                src={phone3}
                srcSet={`${phone32x} 2x`}
                width="379"
                height="757"
                alt="Flexible planning"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Friendly reminders</h1>
            <p className={s.body}>
              Stick to your habits <br />
              with reminders
            </p>
            <div className={s.phone}>
              <img
                src={phone4}
                srcSet={`${phone42x} 2x`}
                width="379"
                height="757"
                alt="Friendly reminders"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Behavioral science</h1>
            <p className={s.body}>
              Learn the science <br />
              behind it all
            </p>
            <div className={s.phone}>
              <img
                src={phone5}
                srcSet={`${phone52x} 2x`}
                width="379"
                height="757"
                alt="Behavioral science"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Dark mode</h1>
            <p className={s.body}>
              Rest your eyes with <br />
              our dark theme
            </p>
            <div className={s.phone}>
              <img
                src={phone6}
                srcSet={`${phone62x} 2x`}
                width="379"
                height="757"
                alt="Dark mode"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Privacy lock</h1>
            <p className={s.body}>
              Keep your habits <br />
              secure and private
            </p>
            <div className={s.phone}>
              <img
                src={phone7}
                srcSet={`${phone72x} 2x`}
                width="379"
                height="757"
                alt="Privacy lock"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
          <div className={s.feature}>
            <h1 className={s.title}>Backup your data</h1>
            <p className={s.body}>
              Signup to keep <br />
              your habits safe
            </p>
            <div className={s.phone}>
              <img
                src={phone8}
                srcSet={`${phone82x} 2x`}
                width="379"
                height="757"
                alt="Backup your data"
              />
            </div>
            <div className={s.bottomBorder} />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Features);
